/* Site-wide contact popup.
 *
 * Opens on any [href="#contact-modal"] or [data-contact-modal] element, so a
 * button opts in through its existing URL field — no schema change, no per-page
 * code.
 *
 * Submits over fetch so the visitor stays on the page they were reading. If
 * anything about that fails, the form is left to submit natively to /contact,
 * which still works and still sends the message.
 */
/* Website field normalisation, for every contact form on the site — the popup
 * and the contact page share one field snippet, so this handles both.
 *
 * The field accepts what people actually type: google.com, www.google.com, or a
 * full URL. On blur a bare domain gets https:// so the address is clickable in
 * the email. Anything that does not look like a domain is left exactly as typed
 * rather than mangled, and nothing here can block a submit.
 */
document.addEventListener(
  'blur',
  function (e) {
    var el = e.target;
    if (!el || el.name !== 'contact[website]') return;
    var v = el.value.trim();
    if (!v) return;
    if (/^[a-z][a-z0-9+.-]*:\/\//i.test(v)) { el.value = v; return; } // already has a scheme
    if (/^[^\s/?#@]+\.[a-z]{2,}([/?#].*)?$/i.test(v)) el.value = 'https://' + v;
    else el.value = v;
  },
  true // capture: blur does not bubble
);

(function () {
  var dialog = document.getElementById('contact-modal');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var form = dialog.querySelector('form');
  var body = dialog.querySelector('[data-contact-modal-body]');
  var success = dialog.querySelector('[data-contact-modal-success]');
  var errorBox = dialog.querySelector('[data-contact-modal-errors]');
  var errorList = dialog.querySelector('[data-contact-modal-errors-list]');
  var btn = form && form.querySelector('button[type="submit"]');
  var btnLabel = dialog.querySelector('[data-contact-modal-btn-label]');
  var originalLabel = btnLabel ? btnLabel.textContent : '';
  var lastTrigger = null;

  function open(trigger) {
    lastTrigger = trigger || null;
    dialog.showModal();
    // Focus the first field rather than the close button, so the visitor can
    // start typing. Deferred a frame: showModal moves focus itself first.
    requestAnimationFrame(function () {
      var first = dialog.querySelector('input:not([type="hidden"]):not([tabindex="-1"])');
      if (first) first.focus();
    });
  }

  function close() {
    dialog.close();
    // Send focus back where it came from, or a keyboard visitor is dropped at
    // the top of the document with no idea where they were.
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-contact-modal], a[href="#contact-modal"]');
    if (trigger) {
      e.preventDefault();
      open(trigger);
      return;
    }
    if (e.target.closest('[data-contact-modal-close]')) {
      e.preventDefault();
      close();
    }
  });

  // Clicking the backdrop closes. The dialog element itself fills the viewport,
  // so a click landing on it rather than on the card is a backdrop click.
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) close();
  });

  function showErrors(messages) {
    if (!errorList || !errorBox) return;
    errorList.innerHTML = '';
    messages.forEach(function (m) {
      var li = document.createElement('li');
      li.textContent = m;
      errorList.appendChild(li);
    });
    errorBox.hidden = false;
    errorBox.scrollIntoView({ block: 'nearest' });
  }

  function setBusy(on) {
    if (btn) btn.disabled = on;
    if (btnLabel) btnLabel.textContent = on ? 'Sending…' : originalLabel;
  }

  if (!form) return;

  form.addEventListener('submit', function (e) {
    if (!form.reportValidity()) return; // let the browser show its own messages
    e.preventDefault();
    if (errorBox) errorBox.hidden = true;
    setBusy(true);

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (res) {
        // Shopify answers a good submit with a redirect carrying
        // contact_posted=true. fetch follows it, so the final URL is the signal
        // — there is no JSON response to read.
        if (res.url && res.url.indexOf('contact_posted=true') !== -1) {
          if (body) body.hidden = true;
          if (success) success.hidden = false;
          // Counted as a lead by snippets/lead-tracking.liquid (GA4 + Google Ads).
          document.dispatchEvent(new CustomEvent('umg:lead', { detail: { form: 'contact_modal' } }));
          return;
        }
        return res.text().then(function (html) {
          // Pull the server's own error text out of the returned page rather
          // than inventing wording that would drift from the contact page.
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelectorAll('.contact-form__errors-list li');
          var messages = [];
          items.forEach(function (li) {
            var t = li.textContent.trim();
            if (t) messages.push(t);
          });
          showErrors(
            messages.length
              ? messages
              : ['Something went wrong sending that. Please email admin@ultramarketinggroup.com.']
          );
        });
      })
      .catch(function () {
        // Network or CORS failure — fall back to a real form post so the
        // message is not silently lost.
        setBusy(false);
        form.submit();
      })
      .then(function () {
        setBusy(false);
      });
  });
})();
